export default {
  phone: '+44 2038 688 669',
  offerLink: 'https://s.algoritmika.org/1tudpoj',
  mailing: 'https://s.algoritmika.org/9s5oiw',
  privacy: 'https://s.algoritmika.org/1t6f0t3',
  currency: '€',
}
